import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/motivos-de-reintegros/';

/**
 * GET Motivos de Reintegro
 * @returns {Promise<Array<object>>}
 */
export const getMotivosDeReintegro = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Motivo de Reintegro
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getMotivoDeReintegro = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Motivo de Reintegro
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMotivoDeReintegro = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Motivo de Reintegro
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMotivoDeReintegro = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Motivo de Reintegro
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteMotivoDeReintegro = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
